import Axios from 'axios';
import { stringify } from 'qs';
import humps from 'humps';

export default class APIService {
  constructor(apiUrl) {
    this.axios = Axios.create({
      baseURL: apiUrl,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain',
      },
    });

    this.axios.interceptors.request.use((config) => {
      window.console.log(config);

      config.paramsSerializer = (params) => {
        // Qs is already included in the Axios package
        const newParams = stringify(params, {
          arrayFormat: 'brackets',
          encode: false,
        });

        console.log('New Params: ');
        console.log(newParams);
        return newParams;
      };

      return config;
    });
    // Format nested params correctly
  }

  trackEvent(event, data) {
    const props = {
      event,
      data,
    };
    return this.axios({
      method: 'post', url: 'track-event', baseURL: '', data: humps.decamelizeKeys(props),
    });
  }

  resumeSub(form) {
    return this.axios.post('resume_sub', humps.decamelizeKeys(form));
  }

  extendGift(form) {
    return this.axios.post('extend_gift', humps.decamelizeKeys(form));
  }

  swapPods(form) {
    return this.axios.post('swap_pods', humps.decamelizeKeys(form));
  }

  lookupFreeTrialOrder(form) {
    return this.axios.post('api/lookup_trial_order', humps.decamelizeKeys(form));
  }

  lookupOrder(form) {
    return this.axios.post('api/lookup_order', humps.decamelizeKeys(form));
  }

  placeOrder(form) {
    return this.axios.post('create_order', humps.decamelizeKeys(form));
  }

  registerGift(form) {
    return this.axios.post('api/register', humps.decamelizeKeys(form));
  }

  emailSupport(form) {
    return this.axios.post('api/email_support', humps.decamelizeKeys(form));
  }
}
